var EqServerExporter = /** @class */ (function () {
    function EqServerExporter(context) {
        this.context = context;
    }
    EqServerExporter.prototype.setFormat = function (format, responseType) {
        this.format = format;
        this.responseType = responseType;
    };
    EqServerExporter.prototype.export = function (exportOptions) {
        exportOptions = exportOptions || {};
        var http = this.context.getServices().getHttpClient();
        var format = this.format || "csv";
        var query = exportOptions.query || this.context.getQuery();
        var modelId = query.getModel().getId();
        var requestData = {
            'settings': exportOptions.settings,
        };
        if (typeof (exportOptions.queryId) !== 'undefined') {
            requestData.queryId = exportOptions.queryId;
        }
        else {
            requestData.query = query.toJSONData();
        }
        if (exportOptions.data) {
            requestData.data = exportOptions.data;
        }
        var url = this.context.resolveEndpoint('ExportResult', { modelId: modelId, format: format });
        var actionResult = http.post(url, requestData, { responseType: this.responseType });
        var request = actionResult.getRequest();
        return actionResult.then(function (responseData) {
            var blob = new Blob([responseData]);
            var dispositionHeader = request.getXMLHttpRequest().getResponseHeader("Content-Disposition");
            var filename = dispositionHeader
                ? dispositionHeader.match(/filename="(.*)"/)[1]
                : 'export-data.' + format;
            if (window.navigator['msSaveOrOpenBlob']) {
                // Internet Explorer
                window.navigator['msSaveOrOpenBlob'](blob, filename);
            }
            else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style.display = "none";
                a.href = window.URL.createObjectURL(blob);
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(a.href);
                document.body.removeChild(a);
            }
        });
    };
    return EqServerExporter;
}());
export { EqServerExporter };
//# sourceMappingURL=eqs_exporter.js.map